module.exports = __webpack_public_path__ + "img/school.f09ae1c8.png";